import React, { useState } from "react";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { Customer_Ets2Affidavits, Ets2_AffidavitCancell } from "data/endpoints";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import Ets2AffidavitSimplified from "features/ets2/components/Ets2AffidavitSimplified";
import Ets2AffidavitSimplifiedHeader from "features/ets2/components/Ets2AffidavitSimplifiedHeader";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import RolesChecker from "features/customer/components/RolesChecker";
import { useTranslation } from "react-i18next";
import { isEnabledCustomForm } from "features/requirements/helpers/requirementTypeHelper";
import { Link } from "react-router-dom";
import { EnabledRequirementType } from "features/requirements/enums/enabledRequirementType";
import Alert from "features/shared/alerts/components/Alert";
import { useInjection } from "infrastructure/ioc/ioc.react";
import IRepository from "data/IRepository";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import PostRequest from "data/PostRequest";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { trackPromise } from "react-promise-tracker";
import ActionResultDTO from "features/shared/dtos/ActionResultDTO";
import { isSuccessStatus } from "data/helpers/responseHelper";

interface Props {}

const Ets2AffidavitsSection = (props: Props) => {
  // translations
  const tLabels = useTranslation("ets2\\ets2").t;

  // DI
  const repo = useInjection<IRepository<object>>(IocTypes.Repository);
  const [reloadGrid, setGridKey] = useState(0);

  const handleCancell = async (id: number | string) => {
    const defaultError: string = tLabels(
      "ets2AffidavitsSection.cancellErrorMessage"
    );

    const postRequest: PostRequest<object> = {
      url: Ets2_AffidavitCancell,
      data: {},
      routeParams: getRouteParams("ets2AffidavitId", String(id)),
    };

    try {
      const response = await trackPromise(
        repo.post<ActionResultDTO<boolean>>(postRequest)
      );

      if (!isSuccessStatus(response) || !response.data?.result) {
        const msgs =
          response.data?.validationMessages
            ?.map((vm) => vm.message)
            .filter(Boolean) || [];

        const errorMessage =
          msgs.length > 0 ? (msgs.join("\n") as string) : defaultError;
        console.error(errorMessage);
      } else {
        setGridKey((k) => k + 1);
      }
    } catch (e) {
      console.error(defaultError, e);
    }
  };

  const renderAddAffidavitBtn = (): JSX.Element => {
    return (
      <RenderWrapper
        isVisible={() => isEnabledCustomForm("ETS2_CESTNEPROHLASENI")}
      >
        <RolesChecker enabledRoles="Contributor">
          <Link
            to={`/requirements/create/${EnabledRequirementType.ETS2_CESTNEPROHLASENI}`}
            className="btn btn-sm btn-secondary mr-n2"
          >
            {tLabels("ets2AffidavitsSection.newAffidavit")}
          </Link>
        </RolesChecker>
      </RenderWrapper>
    );
  };

  const renderNoAddAffidavitsAlert = () => {
    return (
      <Alert alertObj={{ alertType: "Info" }}>
        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
          <span className="mr-sm-2 mb-1 mb-sm-0">
            {tLabels("ets2AffidavitsSection.noAddAffidavitsAlertMessage")}
          </span>
          <div>{renderAddAffidavitBtn()}</div>
        </div>
      </Alert>
    );
  };

  // render
  return (
    <DataGrid
      gridId={DataGridId.ets2AffidavitsGrid}
      url={Customer_Ets2Affidavits}
      renderItem={(item) => (<Ets2AffidavitSimplified affidavit={item} onCancell={handleCancell} />)}
      renderHeader={() => <Ets2AffidavitSimplifiedHeader />}
      renderGridHeaderBtns={renderAddAffidavitBtn}
      renderNoContent={renderNoAddAffidavitsAlert}
      externalDependencies={[reloadGrid]}
    />
  );
};

export default Ets2AffidavitsSection;
